import {useMutation, useQueryClient} from '@tanstack/react-query';

import {useStores} from '../../stores/use-stores';
import {deletePaymentCard} from '../../transport/paymentCardApiV2';

import type {DeletePaymentCardResponse} from './types';
import {PAYMENT_CARD_QUERY_KEY_BASE} from './usePaymentCard';
import {PAYMENT_SERVICES_QUERY_KEY_BASE} from './usePaymentServices';

/**
 * Delete the user's saved payment card
 * Updates cache to null on success and invalidates payment services
 */
export const useDeletePaymentCard = () => {
  const queryClient = useQueryClient();
  const {shopSelectionStore} = useStores();

  return useMutation<DeletePaymentCardResponse, Error, void>({
    mutationFn: deletePaymentCard,
    onSuccess: () => {
      // Get fresh storeId at mutation success time (not stale from hook init)
      const storeId = shopSelectionStore.selectedStore?.id;

      // Guard: skip cache update if no store selected to prevent undefined key pollution
      if (storeId !== undefined) {
        queryClient.setQueryData([...PAYMENT_CARD_QUERY_KEY_BASE, storeId], {card: null});
      }
      // Invalidate payment services to refresh saved_card field (prefix matching)
      queryClient.invalidateQueries({queryKey: PAYMENT_SERVICES_QUERY_KEY_BASE});
    },
  });
};
